import { observer } from "mobx-react-lite";
import FinancierSharedView from "../shared/FinancierSharedView";
import ManualTransfer from "../../components/financier/wallets/ManualTransfer";

export default observer(function ManualTransferPage() {
  return <FinancierSharedView mainContent={<ManualTransfer />} />;
});
